module.exports = __webpack_public_path__ + "media/images/pc/stores/shinjuku/shinjuku_concept_02-e1cadfa2263724ce3ac20d83475411d3.jpg";